var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f7-app',{attrs:{"params":_vm.f7params}},[_c('f7-statusbar'),_vm._v(" "),_c('f7-panel',{attrs:{"id":"leftPanelwrapper","left":"","cover":"","theme-dark":""}},[_c('leftPanel')],1),_vm._v(" "),_c('f7-panel',{attrs:{"right":"","cover":"","theme-dark":""}}),_vm._v(" "),_c('f7-view',{attrs:{"id":"main-view","url":"/","main":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1e791cc4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app.vue
// module id = null
// module chunks = 